export default __webpack_public_path__ + "static/media/blue-upload.0dec8e77.svg";